import { RootState } from "redux/store";

export const selectStomp = (state: RootState) => state.stomp;
export const selectMapStomp = (state: RootState) => state.mapStomp;
export const selectSubscriptionStomp = (state: RootState) =>
  state.subscriptionStomp;
